export default {
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_contactway: '联系方式',
    //数据总览模块
    txt_Wear: '磨损',
    txt_Pwear: '偏磨',
    txt_NoData: '暂无数据',
    txt_GoodState: '良好状态',
    txt_Border: '边界状态',
    txt_replace: '立即更换',
    txt_LightWear: '注意观察',
    txt_GraveWear: '严重磨损',
    txt_sldw: '四轮定位',
    txt_qt: '其他',
    //机会
    txt_ckbg: '查看报告',
    //设备
    txt_beiz: '备注',
    //检测记录
    txt_khsj: '客户手机',
    txt_cphm: '车牌号码',
    txt_clxh: '车辆型号',
    txt_jcsj: '检测时间',
    txt_msqk: '磨损情况',
    txt_zc: '正常',
    txt_qd: '确定',
    txt_sldwd: '四轮定位',
    txt_zcd: '正常',
    txt_fwmd: '服务门店',
    txt_mddz: '门店地址',
    txt_jcsb: '检测设备',
    txt_ddmd: '到店目的',
    txt_lic: '里程',
    txt_chex: '车型',
    txt_jcjyi: '检测建议',
    txt_ysbs: '颜色标识',
    txt_ztms: '整体磨损',
    txt_dqscjltx: '当前刹车距离提醒',
    txt_hwmsjh: '花纹磨损均匀',
    txt_zqlun: '左前轮',
    txt_zhlun: '左后轮',
    txt_yqlun: '右前轮',
    txt_yhlun: '右后轮',
    txt_pingjunzhi: '平均值',
    txt_guige: '规格',
    txt_gongli: '公里',
    txt_ltwjc: '轮胎未检测',
    txt_pinpai: '品牌',
    txt_ltws: '轮胎外观',
    txt_sewmts: '扫描二维码\n查看报告',
    txt_print: '打印',
    //店员管理
    //登录
    //登录新
    //门店
    //商户数据总览
    txt_jianyi: '建议:',
    txt_jianyineirong: '轮胎存在偏磨情况，建议做进一步检查',
    txt_jianyineirongzc: '正常',
    txt_bgtixing: '提醒:',
    txt_bgtuxubfnr: '根据当前轮胎磨损情况,导致刹车距离增加{0}%（预估值）',
    txt_waishang: '外伤',
    txt_laohua: '老化',
    txt_gubao: '鼓包',
    txt_xichemeirong: '洗车美容',
    txt_weixiubaoyang: '维修保养',
    txt_guenghuanluntai: '更换轮胎',
    txt_tireservice: '轮胎服务',
    txt_scsltjcy: '手持式轮胎检测仪',
    txt_lf_outworn: '左前胎外侧比内侧磨损严重',
    txt_lf_innerworn: '左前胎内侧比外侧磨损严重',
    txt_lf_bothsideworn: '左前胎两侧比中间磨损严重',
    txt_lf_centreworn: '左前胎中间比两侧磨损严重',
    txt_lb_outworn: '左后胎外侧比内侧磨损严重',       
    txt_lb_innerworn: '左后胎内侧比外侧磨损严重',        
    txt_lb_bothsideworn: '左后胎两侧比中间磨损严重',        
    txt_lb_centreworn: '左后胎中间比两侧磨损严重',        
    txt_rb_outworn: '右后胎外侧比内侧磨损严重',         
    txt_rb_innerworn: '右后胎内侧比外侧磨损严重',        
    txt_rb_bothsideworn: '右后胎两侧比中间磨损严重',         
    txt_rb_centreworn: '右后胎中间比两侧磨损严重',        
    txt_rf_outworn: '右前胎外侧比内侧磨损严重',         
    txt_rf_innerworn: '右前胎内侧比外侧磨损严重',        
    txt_rf_bothsideworn: '右前胎两侧比中间磨损严重',       
    txt_rf_centreworn: '右前胎中间比两侧磨损严重',  
    txt_tire_need_replace: '有轮胎磨损需要立即更换',
    txt_alignment_chassis: '建议进一步进行四轮定位或底盘检测',
    txt_do_further_check: '请进一步检查',
    txt_uneven_check:'轮胎磨损异常，建议动平衡及对四轮定位,悬架系统进行检查',
    txt_tire_rotation: '建议轮胎换位',           
    txt_wear_normal: '轮胎磨损正常',   
    'txt_wear_normal;': '轮胎磨损正常',
    txt_wheelalignment: '建议动平衡及对四轮定位',     
    txt_tire: '轮胎',
    txt_gelie: '割裂',
    txt_diaokuai: '掉块',
    txt_chaungci: '穿刺',
    txt_cashang: '擦伤',
    txt_wear_overall: '整体磨损',
    txt_pattern_wear: '异常磨损',
    txt_tire_age: '轮胎年限',
    txt_tire_appearance: '轮胎外观',
    txt_tire_age_5:'轮胎有效期已超过5年，建议更换轮胎',
    txt_tire_age_8:'轮胎有效期已超过8年，建议更换轮胎',
    txt_tire_age_6:'轮胎有效期已超过6年，请定期进行检查',
    txt_tire_age_3:'轮胎有效期已超过3年，请定期进行检查',
    txt_tire_age_ok: '轮胎年限良好',
    txt_tire_trauma_check: '轮胎面有外伤，建议做进一步检查',
    txt_install_abnormal_check: '轮胎装反，请确认处理',
    txt_tire_appearance_ok: '轮胎外观良好',
    txt_ltlcgstm: '根据当前轮胎磨损情况,轮胎续航里程为{0}km(预估值)',
    'txt_tire_need_replace;': '有轮胎磨损需要立即更换.',
    'txt_uneven_check;': '轮胎磨损异常，建议动平衡及对四轮定位,悬架系统进行检查',
    'txt_tire_age_ok': '轮胎年限良好',
    'txt_wear_uniform;': '单个轮胎磨损较均匀',    
    txt_wear_uniform: '单个轮胎磨损较均匀',    
    'txt_tire_boundary;': '有轮胎磨损已处边界状态',     
    txt_tire_boundary: '有轮胎磨损已处边界状态', 
    txt_ltxhlcgs: '轮胎续航里程估算',
    txt_ltazhuang: '轮胎安装:',
    txt_dqltlctx: '当前轮胎已到达极限，请立即更换轮胎',
    txt_dottx: '轮胎使用年限估算',
    txt_danweikm: '(单位:km)',
    txt_dotjstx: '轮胎剩余使用时间约为{0}天',
    txt_dotsjztx: '(DOT:轮胎制造日期)',
    'txt_tire_age_ok;': '轮胎年限良好',
    //微信公众号
    txt_sbid: '设备ID',
    txt_jsxm: '技师姓名',
    txt_shoujhm: '手机号码',
    txt_dxyzmm: '短信验证码',
    txt_jishimz: '技师',
    txt_ltlcgsnew: '轮胎续航里程为{0}km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: '羽状磨损',
    txt_msjxtx: '轮胎已达极限,请立即更换',
    txt_ltfz: '内外装反',
    txt_install_check: '安装检查',
    txt_install_ok: '安装正常',
    LF: '[左前轮]',
    RF: '[右前轮]',
    LB: '[左后轮]',
    RB: '[右后轮]',
    FF: '[前轴]',
    BB: '[后轴]',
    txt_appearance_check:'轮胎存在外伤，请维修确认',
    txt_uneven_center:'轮胎中间磨损异常，建议检查胎压',
    txt_uneven_out: '轮胎外侧磨损异常，建议检查四轮定位及胎压',
    txt_pinnate_check: '轮胎存在羽状磨损，建议对底盘件进行进一步检查',
    txt_uneven_inside: '轮胎内侧磨损异常，建议检查四轮定位及胎压',
    'txt_do_further_check;': '请进一步检查',
    txt_uneven_bothside: '轮胎两边磨损异常，建议检查四轮定位及胎压。',
    txt_msyzljgh: '轮胎磨损严重，请立即更换。',
    txt_serious_trauma_check:"轮胎存在严重外伤，建议更换轮胎",
    txt_appearance_lookup:"请检查轮胎外观情况",
    txt_wear_lookup :"请检查轮胎磨损情况",
    txt_dotscsj: '生产时间:{0}({1}年第{2}周)',
    txt_whqdscsj: '未获取到生产时间',
    txt_qiao: '桥',
    txt_left: '左',
    txt_right: '右',
    txt_huawen: '花纹',
    txt_taihao: '胎号',
    txt_taiya: '胎压',
    txt_chexlw: '车型轮位',
    txt_jiancerenyuan: '检测人员',
    txt_beitai:'备胎',
    txt_tuoche:'拖车',
    txt_guache:'挂车',
    txt_chassis_check: '底盘检查',
    txt_chassis_ok: '底盘检查良好',
    txt_chassis_oil: '减震器漏油，建议做进一步确认，必要时请更换处理。',
    txt_chassis_aging: '轴头橡胶老化，建议进行更换处理。',
    // new add  wu
    txt_lights:'灯光',
    txt_high_beam:'远光灯',
    txt_low_beam:'近光灯',
    txt_daytime:'日行灯',
    txt_fog_light:'雾灯',
    txt_brake_light:'刹车灯',
    txt_turn_signals:'转向灯',
    txt_backup_lights:'倒车灯',
    txt_hazards:'应急灯',
    txt_glass:'玻璃',
    txt_windshield:'前风挡',
    txt_back_glass:'后玻璃',
    txt_right_side_windows:'右侧玻璃',
    txt_left_side_windows:'左侧玻璃',
    txt_wipers_front:'前雨刷',
    txt_wipers_rear:'后雨刷',
    txt_under_hood:'发动机舱',
    txt_horn:'喇叭',
    txt_oil_level:'油位',
    txt_air_filter:'空滤',
    txt_trans_fluid:'机油',
    txt_coolant_level:'冷却液液位',
    txt_power_steering_fluid:'转向液',
    txt_windshield_washer_fluid:'玻璃水',
    txt_belts:'皮带',
    txt_hoses:'软管',
    txt_ac_system:'空调系统',
    txt_battery:'蓄电池',
    txt_under_vehicle:'底盘',
    txt_suspension:'悬架',
    txt_exhaust:'排气管',
    txt_brake_lines:'制动管路',
    txt_oil_drain_plug:'放油塞',
    txt_differential:'差异',
    txt_brakes:'刹车',
    txt_front_left:'左前',
    txt_front_right:'右前',
    txt_rear_left:'左后',
    txt_rear_right:'右后',
    txt_parking_brake:'驻车',
    txt_spare_pressure:'备胎',
    txt_interior:'内部',
    txt_cabin_fiter:'活性炭过滤器',
    txt_heating:'暖气装备',
    txt_interior_lights:'内部照明',
    txt_front_defrost:'前除霜',
    txt_rear_defrost:'后除霜',
    txt_tire_pressure:'轮胎',
    txt_left_front:'左前轮',
    txt_right_front:'右前轮',
    txt_left_rear:'左后轮',
    txt_right_rear:'右后轮',
    txt_null:'',
    //cormach
    txt_hood:'发动机舱',
    txt_wash_liquid:'洗涤液',
    txt_level_control:' 液位',
    txt_haoxiaoxi:'正常',
    txt_vedi_Note:'注意 ',
    txt_replace1:'警告',
    txt_radiator_fluid:'防冻液',
    txt_engine_oil:'发动机油',
    txt_brake_fluid:'刹车液',
    txt_quality_control:'品控检查',
    txt_multimeter:'仪表检测',
    txt_subtotal:'小计',
    txt_shock_absorber:'减震器',
    txt_check_loss:' 泄漏检查',
    txt_brake_disc:' 刹车盘',
    txt_wear_condition:'磨损状态',
    txt_brake_pads:'刹车片',
    txt_change_control:'改变控制',
    txt_air_control:'空调系统',
    txt_last_reload:'上一次冷媒补充',
    txt_lighting:'灯光',
    txt_verification1:'雨刮器',
    txt_dynamometer:'扭矩检查',
    txt_batteria:'电池',
    txt_verification:'运转检查',
    txt_levellow:'正常',
    txt_levelmiddle:'工作排程',
    txt_levelhigh:'替换',
    txt_tyrenumber:'扫描深度:',
    txt_cormach_title:'磨损&偏磨',
    txt_wearlow:'花纹磨损均匀',
    txt_wearmiddle:'轻微磨损',
    txt_wearhigh:'严重磨损',
    txt_namtishi:'32度胎面花纹深度',
    txt_zhiliangkongzhi:'质量控制',
    txt_buchongzhengduan:'补充诊断',
    //米其林新加
    txt_trauma_eattyre:'吃胎',
    txt_uneven_eattyre:'轮胎吃胎，建议进行动平衡，以及对四轮定位，悬挂系统进行检查',
    txt_appearance_eattyre:'轮胎吃胎，建议进行动平衡，以及对四轮定位，悬挂系统进行检查',
    txt_chassis_eattyre:'轮胎吃胎，建议对四轮定位，悬挂系统进行检查',
    txt_uneven_high_eattyre:'轮胎严重吃胎，建议更换轮胎，以及对四轮定位，悬挂系统进行检查',
    txt_appearance_high_eattyre:'轮胎严重吃胎，建议进行动平衡，以及对四轮定位，悬挂系统进行检查',
    txt_chassis_high_eattyre:'轮胎严重吃胎，建议对四轮定位，悬挂系统进行检查',
    txt_chassis_uneven:'轮胎异常偏磨，建议对四轮定位，悬挂系统进行检查',
    txt_pianmoyichang:'轮胎偏磨异常',
    txt_khxm:'客户姓名',
    txt_khyx:'客户邮箱',
    txt_tireplace: '轮胎存放地',
    txt_goods_name: '商品名',
    txt_bolt: '螺栓',
    txt_no: '否',
}


// WEBPACK FOOTER //
// ./src/i18n/zh.js